import { ApplicationInfo } from "../../../application/appInfo";
import { Record } from "../../../records/server/crud";
import {
  vsComponentName as configurableGridFormViewComponentName,
  ConfigurableGridFormViewConfig,
} from "../../../records/views/configurableGridFormView";
import { apiKeyStateDefinition } from "../../config/apiKey";
import { vsComponentName as userDetailRolesComponentName } from "./roles/component";
import {
  UserDetailTabsServiceProvider,
  vsProviderName as userDetailTabsServiceProviderName,
} from "./service";
import { vsApiKeyColumns as apiKeyColumnsName } from "../../config/apiKey";
import {
  GridConfiguration,
  vsServiceName as RecordGridViewServiceName,
  RecordGridViewService,
} from "../../../records/views/recordGridView";
import { vsRolePermissionColumns as userRolePermissionObjectName } from "../../config/userRolePermission";

userDetailTabsServiceConfig.$inject = [
  userDetailTabsServiceProviderName,
  "applicationInfo",
];
export function userDetailTabsServiceConfig(
  userDetailTabsServiceProvider: UserDetailTabsServiceProvider,
  applicationInfo: ApplicationInfo
) {
  userDetailTabsServiceProvider.addElement({
    id: "roles",
    displayName: "Roles",
    uiSrefFragment: "roles",
    stateDefinition: {
      url: "/roles",
      component: userDetailRolesComponentName,
      resolve: {},
    },
  });
  userDetailTabsServiceProvider.addElement({
    id: "userPermissions",
    displayName: "Permissions",
    uiSrefFragment: "userPermissions",
    stateDefinition: {
      url: "/userPermissions",
      component: configurableGridFormViewComponentName,
      resolve: {
        gridConfiguration: [
          RecordGridViewServiceName,
          (recordGridViewService: RecordGridViewService): GridConfiguration =>
            recordGridViewService.getGridConfiguration(
              userRolePermissionObjectName
            )!,
        ],
        config: [
          "gridConfiguration",
          "user",
          (
            gridConfiguration: GridConfiguration,
            user: any
          ): ConfigurableGridFormViewConfig => ({
            defaultQuery: { UserAuthId: user.Id },
            gridConfiguration,
          }),
        ],
      },
    },
  });
  if (applicationInfo.isModuleLoaded("authentication.apiKey")) {
    userDetailTabsServiceProvider.addElement({
      id: "apiKeys",
      displayName: "API Keys",
      uiSrefFragment: "apiKeys",
      stateDefinition: apiKeyStateDefinition({
        columnSet: apiKeyColumnsName,
        defaultQueryResolver: [
          "user",
          (user: Record) => ({ Id: user.Id, Active: true }),
        ],
      }),
    });
  }
}
